module.exports = __webpack_public_path__ + "static/img/5f.bbf8db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/consult/image/5f.png
// module id = rRLs
// module chunks = 6